<ng-container *ngIf="cardData;else loading">
  <div class="pageContainer tabcontent marb20" id="allStories" style="display:block;">
    <div class="tabs wid100"> <span class="tablinks bold cursor_auto" onclick="opentab(event, 'allStories')" id="defaultOpen">Create a
        {{storyType}}</span>
        <div class="secondaryCta fr" *ngIf="isLocked && cardData && cardData.metadata && cardData.metadata.status != 'PUBLISHED'" #secondaryCTAs>
          <span class="threedots" (click)="revertListFlag = !revertListFlag">
            <span></span><span></span><span></span>
          </span>
          <div class="revertStoryBlock" *ngIf="revertListFlag">
            <ul><li><button id="buttonDiscardElement" (click)="deleteCurrentElement()">Discard Element</button></li></ul>
          </div>
      </div>
    </div>
    <div [ngSwitch]="storyType">
      <ng-template [ngSwitchCase]="'collection'">
        <div class="tabcontainer pageEditor collections">
          <div class="">
            <div class="allContent">
                <h4>All Content</h4>
                <div class="blockContain">
                    <div class="custom-select">
                  <select [(ngModel)]="Category" class="fr" id="category" >
                    <option value="story" selected>story</option>
                    <option value="page">pages</option>
                  </select>
                  </div>
                   <div *ngIf="Category == 'story'" class="app-page-listing" pageId="all_stories" [isPage]="Category" allApi="all_story"
                    [mergeArticles]="mergeData" [inCollection]="true" [collectionPinIds]="pushPinnedArticles" [getTitle]="cardTitle" showSearch="true" getDragulaId="left" searchApi="all_story" metaApi="dashboard_meta">
                  </div>
                  <div *ngIf="Category == 'page'" class="app-page-listing" pageId="pages" allApi="all_pages" showSearch="true"
                    [mergeArticles]="mergeData" [getTitle]="cardTitle" [getpageName]="pageName" [getSectionName]="sectionName" [getMultiplePageList]="collectionPages" [isMultiplePage]="multiplePageListingFlag" getDragulaId="left" searchApi="all_pages" [isPage]="Category" metaApi="pages_meta">
                  </div>
                  <div class="lockbg" *ngIf="!editCardFlag"></div>
                </div>
            </div>
            <div class="livePage">
                <h4 *ngIf="editCardFlag" id="createdCollectionName">{{cardData.title}}</h4>
                <div class="blockContain">
                  <div *ngIf="Category == 'page' && multiplePageListingFlag===false" class="app-page-listing" pageId="all_stories" allApi="get_story_byids"
                    showCollecton="true" showSearch="false" getDragulaId="right" [isPage]="Category"
                    [pagePinIds]="collectionStories" [pageTopic]="cardData.metadata.topic[0]"
                    [pageSection]="cardData.metadata.section" [getpageName]="pageName"
                    [pageSubSection]="cardData.metadata.subSection" [pageCompany]="cardData.metadata.companyPageName" [getTitle]="cardTitle" [getSectionName]="sectionName"
                    (sendPageDataToParentfn)="getPageDataParentfn($event)" pageArticleApi="collection"></div>

                  <div *ngIf="Category == 'page' && multiplePageListingFlag===true" class="app-page-listing" pageId="all_stories" allApi="get_story_byids"
                    showCollecton="true" showSearch="false" getDragulaId="right" [isPage]="Category" [getpageName]="pageName"
                    [pagePinIds]="collectionStories" [getTitle]="cardTitle" [getSectionName]="sectionName" [getMultiplePageList]="collectionPages" [isMultiplePage]="multiplePageListingFlag"
                    (sendPageDataToParentfn)="getPageMultipleParentFn($event)" (sendPageToBeDeleted)="deleteFromListOfPage($event)" pageArticleApi="collection"></div>
<!-- vb -->
                  <div #storyCollection *ngIf="Category == 'story'" class="app-page-listing" pageId="all_stories" allApi="get_story_byids"
                    showCollecton="true" getDragulaId="right" [isPage]="Category" [getpageName]="pageName" [getSectionName]="sectionName" showSearch="false"
                     [pagePinIds]="collectionStories" [getTitle]="cardTitle" [getnewData]="getnewData" [collectionPinIds]="pushPinnedArticles" (sendListIdToParentfn)="getListIdToParentfn($event)"
                    (sendArticleIdToParentfn)="getArticleIdToParentfn($event)" pageArticleApi="collection"></div>
                    <div class="lockbg" *ngIf="!editCardFlag"></div>
                  </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template [ngSwitchCase]="'communities'">
        <div class="tabcontainer pageEditor collections">
          <div class="">
            <div class="allContent">
                <h4>All Content</h4>
                <div class="blockContain">
                  <div *ngIf="Category == 'page'" class="app-page-listing" pageId="pages" allApi="all_pages" showSearch="true"
                    [mergeArticles]="mergeData" [elementType]='storyType' [getTitle]="cardTitle" [getpageName]="pageName" [getSectionName]="sectionName" [getMultiplePageList]="collectionPages" [isMultiplePage]="true" getDragulaId="left" searchApi="all_pages" [isPage]="Category" metaApi="pages_meta">
                  </div>
                  <div class="lockbg" *ngIf="!editCardFlag"></div>
                </div>
            </div>
            <div class="livePage">
                <h4 *ngIf="editCardFlag">{{cardData.title}}</h4>
                <div class="blockContain">
                  <div *ngIf="Category == 'page'" class="app-page-listing" pageId="all_stories" allApi="get_story_byids"
                    showCollecton="true" showSearch="false" getDragulaId="right" [isPage]="Category" [getpageName]="pageName"
                    [pagePinIds]="collectionStories" [getTitle]="cardTitle" [getSectionName]="sectionName" [getMultiplePageList]="collectionPages" [isMultiplePage]="true"
                    (sendPageDataToParentfn)="getPageMultipleParentFn($event)" (sendPageToBeDeleted)="deleteFromListOfPage($event)" pageArticleApi="collection"></div>

                    <div class="lockbg" *ngIf="!editCardFlag"></div>
                  </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template [ngSwitchCase]="'toptrends'">
        <div class="tabcontainer embedform">
          <div class="formStory fl100">
            <ul class="storyuL">
              <li class="trendingEditBlock">
                <div (mouseenter) ="hoverEnter()"  (mouseleave) ="hoverLeave()">
                  <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
                    Enter Topic Name
                  </label>
                  <div [class]="disableElement() ? 'dataField bdrfill' : 'dataField'" >
                    <input type="text" id="textTopics" [(ngModel)]="trending" class="textBox topicInput" placeholder="Add Top Trends & Trending Topics">
                    <input type="text" id="textTopicURL" [(ngModel)]="trendingUrl" class="textBox topicUrlInput" placeholder="Add URL here">
                  </div>
                  <div class="storyaction">
                    <span (click)="addTopicTrends('add','')" class="addUserBtn addDomain"><i class="icon-add" id="addIcon"></i></span>
                  </div>
                </div>
              </li>

              <li [dragula]="'second-bag-new'" [(dragulaModel)]='objKeys'>
                <div class="trendingListBlock" *ngFor="let item of objKeys">
                <div (mouseenter) ="hoverEnter()"  (mouseleave) ="hoverLeave()" *ngIf="(objKeys.length > 0)">
                  <label [style.visibility]="(isCursorHovering ? 'hidden' : 'hidden')">
                    &nbsp;
                  </label>
                  <div [class]="disableElement() ? 'dataField bdrfill' : 'dataField'" >
                    <input type="text" [(ngModel)]="item.key" class="textBox topicInput" (click)="addTopicTrends('edit', item)" placeholder="Add Top Trends & Trending Topics">
                    <input type="text" [(ngModel)]="item.value" class="textBox topicUrlInput" (click)="addTopicTrends('edit', item)" placeholder="Add URL here">
                  </div>
                  <div class="storyaction"  *ngIf="editCardFlag && (isCursorHovering)">
                    <span class="handle sortpara" *ngIf="objKeys.length > 1"><i class="icon-move secondbag"></i></span>
                    <span class="closeRole" (click)="addTopicTrends('delete',item)"><i class="icon-delete"></i></span>
                  </div>
                </div>
              </div>
            </li>
            </ul>
      </div>
    </div>
      </ng-template>
      <ng-template [ngSwitchCase]="'banner'">
        <div class="tabcontainer embedform">
          <div class="formStory fl100">
            <ul class="storyuL">
              <li class="trendingEditBlock">
                <div (mouseenter) ="hoverEnter()"  (mouseleave) ="hoverLeave()">
                  <div class="bannerBlock bdrfill">
                  <div class="blockLi">
                  <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
                    Enter Banner Details
                  </label>
                  <div [class]="disableElement() ? 'dataField' : 'dataField'" >
                    <input type="text" [(ngModel)]="bannerName" class="textBox bannerName" placeholder="Add Banner Name">
                    <input type="text" [(ngModel)]="bannerUrl" class="textBox bannerUrl" placeholder="Add Landing URL">
                  </div>
                </div>
                  <div class="blockLi">
                    <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Image Selection</label>
                    <div [class]="disableElement() ? 'dataField' : 'dataField'">
                      <div class="affiBannerImage">
                        <div class="imageInsert">
                          <span>Upload from file</span>
                          <input type="file" name="myfile" accept="image/*" (change)="onFileChange($event,true)"  />
                        </div>
                        <div class="imageLibrary">
                          <span tabindex="0" (click)="showGallery()" class="pickimageBtn">Pick
                            from Image Library</span>
                          <div class="lightBox photogallerylist block" *ngIf="isLightbox">
                            <div class="headerLight">
                              <div class="close fl spImg" (click)="disableshowGallery()"></div>
                            </div>
                            <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getImageId($event, true,true)"
                                *ngIf="isPhotopopup"></div>
                          </div>
                        </div>
                        </div>
                        <ng-container *ngIf="tempBannerImgUrl">
                          <img src="{{tempBannerImgUrl}}" alt="">
                          <div class="storyaction">
                            <span class="closeRole" (click)="deleteTempBanner()"><i class="icon-delete"></i></span>
                          </div>
                        </ng-container>
                    </div>
                    </div>
                  </div>
                  <div class="storyaction">
                    <span (click)="addBanner('add','')" class="addUserBtn addDomain"><i class="icon-add"></i></span>
                  </div>
                </div>
              </li>

              <li [dragula]="'second-bag-new'" [(dragulaModel)]='cardData.banner'>
                <div class="bannerListBlock" *ngFor="let item of cardData.banner; let i = index">
                <div (mouseenter) ="hoverEnter()"  (mouseleave) ="hoverLeave()" *ngIf="(cardData.banner.length > 0)">
                  <div class="bannerBlock bdrfill">
                    <div class="blockLi">
                  <label [style.visibility]="(isCursorHovering ? 'hidden' : 'hidden')">
                    &nbsp;
                  </label>
                  <div [class]="disableElement() ? 'dataField' : 'dataField'" >
                    <input type="text" [(ngModel)]="cardData.banner[i]['key']" class="textBox bannerName"  placeholder="Add Top Trends & Trending Topics">
                    <input type="text" [(ngModel)]="cardData.banner[i]['value']" class="textBox bannerUrl"  placeholder="Add URL here">
                  </div>
                  </div>
                  <div class="blockLi">

                    <label [style.visibility]="(isCursorHovering ? 'hidden' : 'hidden')">
                      &nbsp;
                    </label>
                    <div [class]="disableElement() ? 'dataField' : 'dataField'" >
                      <div class="affiBannerImage">
                    <img src="{{cardData.banner[i]['imageUrl']}}" alt="">
                    </div>
                  </div>
                    </div>
                  </div>
                  <div class="storyaction"  *ngIf="editCardFlag && (isCursorHovering)">
                    <span class="handle sortpara" *ngIf="cardData.banner.length > 1"><i class="icon-move secondbag"></i></span>
                    <span class="closeRole" (click)="deleteBanner(i)"><i class="icon-delete"></i></span>
                  </div>
                </div>
              </div>
            </li>
            </ul>
      </div>
        </div>
      </ng-template>
      <div class="image-cropper" *ngIf="showCropper" [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event)" [bannerCrop]='true'
      (cancel)="cancelCropping($event)"></div>

      <ng-template [ngSwitchCase]="'chart'">
        <div class="tabcontainer embedform">
          <div class="formStory fl100">
            <ul class="storyuL">
              <li>
                <div #tableEl tabindex="0">
                  <label>Chart</label>
                  <div class="dataField bdrfill table" [innerHTML]="cardData.chart.chartBody"></div>
                  <div class="storyaction">
                    <span class="editBtn" (click)="editTable()"><i class="icon-pickup"></i></span>
                  </div>
                  <div class="dataField pdl92">
                  <canvas id="chartCanvas"></canvas>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </ng-template>
      <ng-template [ngSwitchCase]="'table'">
        <div class="tabcontainer embedform">
          <div class="formStory fl100">
            <ul class="storyuL">
              <li>
                <div #tableEl tabindex="0">
                  <label>Table</label>
                  <div class="dataField bdrfill table" [innerHTML]="cardData.paragraph.body"></div>
                  <div class="storyaction">
                    <span class="editBtn" (click)="editTable()"><i class="icon-pickup"></i></span>
                  </div>
                  <div class="dataField pdl92">
                  <canvas id="chartCanvas"></canvas>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </ng-template>
      <ng-template ngSwitchDefault>
        <div class="tabcontainer embedform">
          <div class="formStory fl100">
            <ul class="storyuL">
              <li>
                <ng-container *ngIf="(cardData.amazonMeta);then amazonData else embedData"></ng-container>

                <ng-template #amazonData>
                  <div (mouseenter) ="hoverEnter()"  (mouseleave) ="hoverLeave()">
                    <label id="embedCode" [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
                      Embed Code
                    </label>
                    <div [class]="disableElement() ? 'dataField bdrfill' : 'dataField'" >
                      <p id="embeddCodePage">
                        <ng-container *ngIf="cardData.amazonAds && cardData.amazonAds.length > 0">
                          <ng-container *ngFor="let amazonAd of cardData.amazonAds">
                            <!-- {{amazonAd.key}} : {{amazonAd.value}} <br><br> -->
                          </ng-container>
                        </ng-container>
                      </p>
                    </div>
                    <div class="storyaction"  *ngIf="editCardFlag && (isCursorHovering)">
                      <span class="editBtn" id="embedCodeEditIcon" (click)="onelementFocus()"><i class="icon-pickup"
                        *ngIf="editCardFlag"></i></span>
                    </div>
                    </div>
                </ng-template>
                <ng-template #embedData>
                <div (mouseenter) ="hoverEnter()"  (mouseleave) ="hoverLeave()">
                  <label id="embedCode" [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
                    Embed Code
                  </label>
                  <div [class]="disableElement() ? 'dataField bdrfill' : 'dataField'" *ngIf="cardData.embed.body">
                    <ng-container *ngIf="(
                      cardData.embed.body.indexOf('youtube.com') === -1 &&
                      cardData.embed.body.indexOf('https://twitter.com') === -1 &&
                      cardData.embed.body.indexOf('https://www.instagram.com') === -1
                      ) || !trustedHTML">
                      <p id="embeddCodePage">
                        {{cardData.embed.body}}
                      </p>
                    </ng-container>
                    <ng-container *ngIf="trustedHTML && ((
                      cardData.embed.body.indexOf('youtube.com') > -1 ||
                      cardData.embed.body.indexOf('https://twitter.com') > -1 ||
                      cardData.embed.body.indexOf('https://www.instagram.com') > -1
                      ))">
                      <div [class]="(cardData.embed.body.indexOf('https://twitter.com') > -1) ? 'twitterEmbed'
                        : ((cardData.embed.body.indexOf('https://www.instagram.com') > -1) ? 'instagramEmbed' : 'respVideo')"
                        [innerHtml]="trustedHTML"></div>
                    </ng-container>
                  </div>
                  <div class="storyaction"  *ngIf="editCardFlag && (isCursorHovering)">
                    <span class="editBtn" id="embedCodeEditIcon" (click)="onelementFocus()"><i class="icon-pickup"
                      *ngIf="editCardFlag"></i></span>
                  </div>
                  </div>
                  <div (mouseenter) ="hoverEnter()"  (mouseleave) ="hoverLeave()" *ngIf="storyType == 'embed'">
                    <label id="embedCode2" [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
                      Embed Code 2
                    </label>
                    <div [class]="disableElement() ? 'dataField bdrfill' : 'dataField'" *ngIf="cardData.embed.body2">
                      <ng-container *ngIf="(
                        cardData.embed.body2.indexOf('youtube.com') === -1 &&
                        cardData.embed.body2.indexOf('https://twitter.com') === -1 &&
                        cardData.embed.body2.indexOf('https://www.instagram.com') === -1
                        ) || !trustedHTML2">
                        <p id="embeddCodePage2">
                          {{cardData.embed.body2}}
                        </p>
                      </ng-container>
                      <ng-container *ngIf="trustedHTML2 && ((
                        cardData.embed.body2.indexOf('youtube.com') > -1 ||
                        cardData.embed.body2.indexOf('https://twitter.com') > -1 ||
                        cardData.embed.body2.indexOf('https://www.instagram.com') > -1
                        ))">
                        <div [class]="(cardData.embed.body2.indexOf('https://twitter.com') > -1) ? 'twitterEmbed'
                          : ((cardData.embed.body2.indexOf('https://www.instagram.com') > -1) ? 'instagramEmbed' : 'respVideo')"
                          [innerHtml]="trustedHTML2"></div>
                      </ng-container>
                    </div>
                    <div class="storyaction"  *ngIf="editCardFlag && (isCursorHovering)">
                      <span class="editBtn" id="embedCodeEditIcon2" (click)="onelementFocus()"><i class="icon-pickup"
                        *ngIf="editCardFlag"></i></span>
                    </div>
                    </div>
              </ng-template>
              </li>
            </ul>
        </div>
        </div>

        <div class="lightBox embeddblock block" *ngIf="embedPopup">
            <div class="unlockStory" id=" embedPopupList">
              <div class="wid100 pad30">
                <h3 id="embeddTitle">{{popupTitle}}</h3>
              <div class="amazonAds">
                <label>Amazon Meta</label>
              <div class="dataField">
                <label class="switch" tabindex="0">
                  <input type="checkbox" (click)="toggleEmbedSwitch()" [checked]="showAmazonMeta || (cardData.amazonAds && cardData.amazonAds.length > 0)">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
              <ng-container *ngIf="(showAmazonMeta);then amazonData else embedData"></ng-container>

              <ng-template #amazonData>
                <div class="amazonAds">
                  <label>Add Amazon Custom Ads</label>
                  <span id="headline1" class="plusHeadline" (click)="addAmazonMeta()">
                    <i class="icon-add-headline"></i>
                  </span>
                  </div>
                  <ng-container *ngIf="amazonNewAd">
                    <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="newAdName" placeholder="Enter Ad Name here" tabindex="0"></textarea>
                    <textarea type="text" class="textBoxSmall" [(ngModel)]="newAdEmbed" placeholder="Enter Ad Embed here" tabindex="0"></textarea>
                    <button type="button" tabindex="0" name="unlock" (click)="saveAmazonEmbed()" class="add blue ml10 amazonAddSpace">Add</button>
                  </ng-container>
                  <div [dragula]="'new-bag'" [(dragulaModel)]='cardData.amazonAds'>
                  <ng-container *ngFor="let amazonAd of amazonAds; let i =index">
                    <div class="container embedCallBlock" >
                    <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="amazonAd.key" placeholder="Enter ad name here..." tabindex="0"></textarea>
                    <textarea type="text" class="textBoxSmall" [(ngModel)]="amazonAd.value" placeholder="Enter Custom {{amazonAd.key}} here" tabindex="0"></textarea>
                    <span class="deleteHeadline amazonAddSpace" id="headline2" (click)="deleteAmazonAd(i)">
                      <i class="icon-delete"></i>
                    </span>
                    <span class="handle sortpara" *ngIf="amazonAds.length > 1"><i class="icon-move newbag"></i></span>
                    </div>
                  </ng-container>
                </div>

                </ng-template>
                <ng-template #embedData>

                    <label>{{(storyType == 'embed') ? getEmbedPopupTitle() : 'Add URL for the video, tweet, etc'}}</label>
                    <textarea type="text" id="inputAddJson" class="textBox" [(ngModel)]="embedCode" placeholder="Enter for the Facebook, tweet, etc here…" tabindex="3"></textarea>
                    <label *ngIf="storyType == 'embed'">Embed for Dark Mode (App Only)</label>
                    <textarea *ngIf="storyType == 'embed'" type="text" class="textBox" [(ngModel)]="embedCode2" placeholder="Enter for the Facebook, tweet, etc here…" tabindex="3"></textarea>

                </ng-template>
            </div>



              <div class="fr wid100 right padlr30 ptb15">
                <button type="button" id="cancelButton" name="cancel" (click)="closeEmbedPopup()" class="cancel gray ml10">Cancel</button>
                <button type="button" id="addJsonDoneButton" name="unlock" (click)="changeEmbed()" class="add blue ml10">Done</button>
              </div>
            </div>
        </div>
      </ng-template>
    </div>
    <div class="clearBoth"></div>
  </div>

  <div class="thirdContainer collections">
    <div class="usermeta blocks marb20">
      <div class="head" id="metaDataHeader">Metadata</div>
      <div class="form">
        <ul>
          <ng-container *ngIf="editCardFlag;then editMode else newMode"> </ng-container>
          <ng-template #newMode>
            <li>
              <label>Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!editCardFlag" id="inputAddNameText"
                [(ngModel)]="cardData.title"
                placeholder="Add element name here…">
              </div>
            </li>

            <li *ngIf="storyType == 'collection'">
              <label>Display Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!editCardFlag" id="inputDisplayNameText"
                [(ngModel)]="cardData.displayName"
                placeholder="Add Display name here…">
              </div>
            </li>

            <li *ngIf="storyType == 'collection'">
                <label>Design</label>
              <div class="dataField">
                <input type="text" class="textBox" #sectionInput placeholder="Select design here." readonly
                [(ngModel)]="sectionQuery" (click)="filterAutoComplete()">
                <div class="autosuggestion block" *ngIf="storyType == 'collection' && filteredDesignSuggestion && filteredDesignSuggestion.length > 0">
                  <ul *ngFor="let item of filteredDesignSuggestion">
                    <li (click)="selectAutoComplete(item, 'design')">
                      <span class="name">{{item.value}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideDesign && (1 > filteredDesignSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li><span class="name">No Results</span></li>
                    </ul>
                  </div>
                </ng-container>
              </div>
            </li>
            <li *ngIf="storyType == 'collection' && (domainConfig && domainConfig['config']
            && domainConfig['config']['collection'] && domainConfig['config']['collection']['collectionType'] === 'true')">
              <label>Collection</label>
              <div class="dataField">
                <input type="text" class="textBox" #collectionTypeInput placeholder="Select collection type here." readonly
                [(ngModel)]="collectionTypeQuery" (click)="filterCollectionTypeAutoComplete()">
                <div class="autosuggestion block" *ngIf="storyType == 'collection' && filteredCollectionTypeSuggestion && filteredCollectionTypeSuggestion.length > 0">
                  <ul *ngFor="let item of filteredCollectionTypeSuggestion">
                    <li (click)="selectAutoComplete(item, 'collectionType')">
                      <span class="name">{{item.value}}</span>
                    </li>
                  </ul>
                </div>

                <div class="autosuggestion block" *ngIf="storyType == 'collection' && insideCollectionType && filteredCollectionTypeSuggestion && 1 > filteredCollectionTypeSuggestion.length">
                  <ul>
                    <li><span class="name">No Results</span></li>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <label>Tags</label>
              <div class="dataField">
                <ul id="myKeyword" class="tagit">
                  <li class="tagit-new">
                    <tags-creator [broadInput]="true" [idInput]="'inputAddTagsText'" [editable]="!editCardFlag" [data]="cardData.metadata.tags"
                      [displayText]="'enter tags'" (changefn)="cardData.metadata.tags = $event"></tags-creator>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <ng-container *ngFor="let newMeta of newMetas; index as i">
                <ng-container *ngIf="(newMeta.collectionType.indexOf(storyType) > -1) && newMeta.active">
                    <new-metadata [addedMeta]="newMeta" [checkedField]="getStoryDynamicMetaIndex(newMeta.field)"
                    (emitToggleValue)="saveDynamicMetaValue($event,newMeta.field)">
                    </new-metadata>
                </ng-container>
              </ng-container>
            </li>
            <li>
              <label>External URL</label>
              <div class="dataField">
                <input type="text" [class]="(s_url.value && s_url.invalid) ? 'textBox errorInput' : 'textBox'"
                 [(ngModel)]="externalUrl"
                placeholder="Add external Url here…">
              </div>
            </li>

            <li *ngIf="storyType == 'collection' && Category == 'story' && isSectionAndSubSectionEnabled()">
                <label>Section</label>
                <div class="dataField">
                    <input type="text" id="inputAddSectionText" class="textBox" [readonly]="!editCardFlag" placeholder="Add Section here."
                      [(ngModel)]="cardData.metadata.section">
                  </div>
            </li>
            <li *ngIf="storyType == 'collection' && Category == 'story' && isSectionAndSubSectionEnabled()">
                <label>Sub-section</label>
                <div class="dataField">
                    <input type="text" id="inputAddSubSectionText" class="textBox" [readonly]="!editCardFlag"
                      placeholder="Add SubSection here." [(ngModel)]="cardData.metadata.subSection">
                  </div>
            </li>



          </ng-template>
          <ng-template #editMode>
            <li>
              <label>Name</label>
              <div class="dataField">
                <input type="text" [class]="cardData.title ? 'textBox' : 'textBox errorInput'" id="inputAddNameText"
                [(ngModel)]="cardData.title"
                  placeholder="Add element name here…">
              </div>
            </li>

            <li *ngIf="storyType == 'collection'">
              <label>Display Name</label>
              <div class="dataField">
                <input type="text" [class]="textBox" id="inputDisplayNameText"
                [(ngModel)]="cardData.displayName"
                  placeholder="Add Display name here…">
              </div>
            </li>

            <li *ngIf="storyType == 'collection'">
              <label>Design</label>
            <div class="dataField">
              <input type="text" class="textBox" #sectionInput placeholder="Select design here."
              readonly
              [(ngModel)]="sectionQuery"
                (click)="filterAutoComplete()">
                <ng-container *ngIf="sharedService.isdomainConfig('collection','previewDesign')">

                <span class="clickdesign"><i (click)="openDesignPopup()">Click Here</i> for Design Layout</span>
                <div class="lightBox embeddblock block" *ngIf="designPopup">
                  <div class="unlockStory" style="text-align: center;">
                    <img [src]='designImage' class="designImage" alt="">
                    <div class="fr wid100 right padlr30 ptb15">
                      <button type="button" name="cancel" (click)="closeDesignPopup()" class="cancel gray">Cancel</button>
                   </div>
                    </div>
                </div>
              </ng-container>
              <div class="autosuggestion block" *ngIf="storyType == 'collection' && filteredDesignSuggestion && filteredDesignSuggestion.length > 0">
                <ul *ngFor="let item of filteredDesignSuggestion">
                  <li (click)="selectAutoComplete(item,'design')">
                    <span class="name">{{item.value}}</span>
                  </li>
                </ul>
              </div>
              <ng-container *ngIf="insideDesign && (1 > filteredDesignSuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li><span class="name">No Results</span></li>
                  </ul>
                </div>
              </ng-container>
            </div></li>
            <li *ngIf="storyType == 'collection' && (domainConfig && domainConfig['config']
            && domainConfig['config']['collection'] && domainConfig['config']['collection']['collectionType'] === 'true')">
              <label>Collection</label>
              <div class="dataField">
                <input type="text" class="textBox" #collectionTypeInput placeholder="Select collection type here." readonly
                [(ngModel)]="collectionTypeQuery" (click)="filterCollectionTypeAutoComplete()">
                <div class="autosuggestion block" *ngIf="storyType == 'collection' && filteredCollectionTypeSuggestion && filteredCollectionTypeSuggestion.length > 0">
                  <ul *ngFor="let item of filteredCollectionTypeSuggestion">
                    <li (click)="selectAutoComplete(item, 'collectionType')">
                      <span class="name">{{item.value}}</span>
                    </li>
                  </ul>
                </div>
                <div class="autosuggestion block" *ngIf="storyType == 'collection' && insideCollectionType && filteredCollectionTypeSuggestion && 1 > filteredCollectionTypeSuggestion.length">
                  <ul>
                    <li><span class="name">No Results</span></li>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <label>Tags</label>
              <div class="dataField">
                <ul id="myKeyword" class="tagit">
                  <li class="tagit-new">
                    <tags-creator [idInput]="'inputAddTagsText'" [data]="cardData.metadata?.tags" [displayText]="'Add tag here..'" (changefn)="cardData.metadata.tags = $event"></tags-creator>

                  </li>
                </ul>
              </div>
            </li>

            <li>
              <label>External URL</label>
              <div class="dataField">
                  <form [formGroup]="form">
                <input type="text" [class]="checkErrorStatus('url') ? 'textBox errorInput' : 'textBox'"
                [(ngModel)]="externalUrl" id="s_url" formControlName="s_url" (change)="checkExternalURL(externalUrl)"
                placeholder="Add external Url here…">
                </form>
              </div>
            </li>
            <li *ngIf="storyType === 'collection'">
              <label>
                Brunch Edition
              </label>
              <div class="dataField">
                <input type="text" class="textBox"  #brunchInput placeholder="Add brunch edition here."
                  [(ngModel)]="selectedBrunchEdition" (keyup)="filterAutoCompleteUpBrunch($event)" (keydown)="filterAutoCompleteDown($event ,'brunch')"
                  (focus)="focusBrunch()" (focusout)="false">
                <ng-container>
                  <div #brunchList class="autosuggestion block" id="inputAddSectionActiveText" *ngIf="brunchEditionFilter && brunchEditionFilter.length > 0 && insideBrunch">
                    <ul *ngFor="let item of brunchEditionFilter;let i = index">
                      <li (click)="selectAutoComplete(item, 'brunch')" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="insideBrunch && (1 > brunchEditionFilter.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </ng-container>

              </div>
            </li>
            <li>
            <ng-container *ngFor="let newMeta of newMetas; index as i">
              <ng-container *ngIf="(newMeta.collectionType.indexOf(storyType) > -1) && newMeta.active">
                  <new-metadata [editable]="editCardFlag" [addedMeta]="newMeta" [checkedField]="getStoryDynamicMetaIndex(newMeta.field)"
                  (emitToggleValue)="saveDynamicMetaValue($event,newMeta.field)">
                  </new-metadata>
              </ng-container>
            </ng-container>
            </li>

            <li *ngIf="storyType === 'collection'">
              <!-- <label>APP</label>
              <div class="dataField">
                <label class="switch" tabindex="0">
                  <input type="checkbox" [checked]="cardData.metadata.app" (click)="toggleSwitch('APP')">
                  <span class="slider round"></span>
                </label>
              </div>
            </li>

            <li *ngIf="storyType === 'collection'">
              <label>AMP</label>
              <div class="dataField">
                <label class="switch" tabindex="0">
                  <input type="checkbox" [checked]="cardData.metadata.amp" (click)="toggleSwitch('AMP')">
                  <span class="slider round"></span>
                </label>
              </div>
            </li> -->

            <!-- <li *ngIf="storyType === 'collection' && sharedService.isdomainConfig('collection','webFlagEnabled')">
              <label>WEB</label>
              <div class="dataField">
                <label class="switch" tabindex="0">
                  <input type="checkbox" [checked]="cardData.metadata.web" (click)="toggleSwitch('WEB')">
                  <span class="slider round"></span>
                </label>
              </div>
            </li> -->

            <li *ngIf= "Category =='page' && (domainConfig && domainConfig['config']
            && domainConfig['config']['pages'] && domainConfig['config']['pages']['multiplePages'] === 'true') && storyType !== 'communities'">
              <label>Multiple Pages</label>
              <div class="dataField">
                <label class="switch" tabindex="0">
                  <input type="checkbox" id="inputToggle" (click)="toggleMultiplePage()" [(checked)]="multiplePageListingFlag">
                  <span class="slider round"></span>
                </label>
              </div>
            </li>
            <li *ngIf="storyType == 'collection' && Category == 'story' && isSectionAndSubSectionEnabled()">
                <label>Section</label>
                <div class="dataField">
                    <input type="text" id="inputAddSectionText" class="textBox" #section [readonly]="!editCardFlag" placeholder="Add Section here."
                      [(ngModel)]="sectionInputQuery" (keyup)="filterAutoCompleteKeyUp($event ,'section')" (keydown)="filterAutoCompleteKeyDown($event ,'section')"
                      (focus)="focusInSuggestion('section')" (focusout)="false">

                      <div #sectionList class="autosuggestion block" id="inputAddSectionActiveText" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0">
                        <ul *ngFor="let item of filteredSectionSuggestion;let i = index">
                          <li (click)="selectAutoComplete(item,'section')" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                            <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideSection && (1 > filteredSectionSuggestion.length)">
                          <div class="autosuggestion block" id="inputAddSectionActiveText">
                            <ul>
                              <li><span class="name">No Results</span></li>
                            </ul>
                          </div>
                        </ng-container>

                  </div>
            </li>
            <li *ngIf="storyType == 'collection' && Category == 'story' && isSectionAndSubSectionEnabled()">
                <label>Sub-section</label>
                <div class="dataField">
                    <input type="text" class="textBox" #subSectionInput [readonly]="!editCardFlag"
                      placeholder="Add SubSection here." id="inputAddSubSectionText" [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteKeyUp($event ,'subSection')"
                      (keydown)="filterAutoCompleteKeyDown($event ,'subSection')" (focus)="focusInSuggestion('subSection')"
                      (focusout)="false">
                      <div #subSectionList class="autosuggestion block" id="inputAddSubSectionActiveText" *ngIf="filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                        <ul *ngFor="let item of filteredSubSectionSuggestion; let i = index">
                          <li (click)="selectAutoComplete(item,'subSection')" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideSubSection && (1 > filteredSubSectionSuggestion.length)">
                          <div class="autosuggestion block" id="inputAddSubSectionActiveText">
                            <ul>
                              <li><span class="name">No Results</span></li>
                            </ul>
                          </div>
                        </ng-container>
                  </div>
            </li>
            <li *ngIf="storyType === 'collection'">
              <label>
                Series Page
              </label>
              <div class="dataField">
                <input type="text" class="textBox"  #seriesPageInput placeholder="Add series page here."
                  [(ngModel)]="selectedSeriesPage" (keyup)="filterAutoCompleteUpSeriesPage($event)" (keydown)="filterAutoCompleteDown($event ,'seriesPage')"
                  (focus)="focusSeriesPage()" (focusout)="false">
                <ng-container>
                  <div #seriesPageList class="autosuggestion block" id="inputAddSectionActiveText" *ngIf="seriesPageFilter && seriesPageFilter.length > 0 && insideSeriesPage">
                    <ul *ngFor="let item of seriesPageFilter;let i = index">
                      <li (click)="selectAutoComplete(item, 'seriesPage')" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                      </li> 
                    </ul>
                  </div>
                  <ng-container *ngIf="insideSeriesPage && (1 > seriesPageFilter.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </li>
            <li *ngIf="storyType == 'collection' && Category == 'story' && isSectionAndSubSectionEnabled()">
              <label>Story Count</label>
              <div class="dataField">
                <input type="text" [class]="'textBox '" maxlength="3"
                [(ngModel)]="cardData.metadata.count" nuberInput [value]="10"
                placeholder="Add count here…">
              </div>
            </li>

            <ng-container *ngIf="storyType == 'embed'">

              <li>
                <label>Title</label>
                <div class="dataField">
                  <input placeholder="Add element Title here…" id="titleUnderMetaData" type="text" class="textBox"
                  [(ngModel)]="cardData.embed.title" >
                </div>
              </li>
              <li>
                <label>Background Color</label>
                <div class="dataField">
                  <select name="backgroundColor" class="select-wrapper" [(ngModel)]="backColor"
                  (change)="selectChangeHandler($event)">
                  <option values='#ffffff' selected>White</option>
                  <option values='#000000'>Black</option>
                </select>
                </div>
              </li>
              <li>
                <label>Font Color</label>
                <div class="dataField">
                  <input placeholder="{{color}}"
                  type="text" disabled class="textBox">
                </div>
              </li>
              <li>
                  <label>JSON Source Url</label>
                  <div class="dataField">
                    <input type="text" id="inputAddJsonSourceUrl"
                    [(ngModel)]="cardData.jsonSourceUrl"
                      placeholder="Add jsonSourceUrl here…">
                  </div>
                </li>
                <li>
                  <label>Subtype</label>
                  <div class="dataField">
                    <input type="text" id="subtypeUnderMetaData"
                    [(ngModel)]="cardData.subType"
                      placeholder="Add Subtype here…">
                  </div>
                </li>
                  <!-- Tag Type -->
          <li *ngIf="enableTagTypeApp">
            <label>Tag Type App</label>
            <div class="dataField">
              <input type="text" class="textBox" id="inputAddTagType" #tagTypeInput placeholder="Add TagType here."
                [(ngModel)]="tagtypeQuery" (keyup)="filterAutoCompleteUpTagType($event)" (keydown)="filterAutoCompleteDownTagType($event)"
                (focus)="focusInSuggestTagType('agency')" (focusout)="false">
              <ng-container >
                <div class="autosuggestion block" *ngIf="filteredtagTypeSuggestion && filteredtagTypeSuggestion.length > 0">
                  <ul *ngFor="let item of filteredtagTypeSuggestion; let i = index">
                    <li #agencyList (click)="selectAutoCompleteTagType(item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                      <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideTagType && (filteredtagTypeSuggestion && 1 > filteredtagTypeSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
          <div>
            <li>
              <label>Date</label>
              <div class="dataField">
                <input type="date" class="textBox" id="{{cardData.metadata.date}}"
                [ngModel]="cardData.metadata.date | date: 'yyyy-MM-dd'" (ngModelChange)="updatePositionDate($event)" placeholder="Add Date">
              </div>
            </li>
            <li>
                <label>Position</label>
                <div class="dataField">
                  <input type="text" class="textBox" #positionTypeInput placeholder="Select position here." readonly
                  [(ngModel)]="positionTypeQuery" (click)="filterPositionTypeAutoComplete()">
                  <div class="autosuggestion block" *ngIf="storyType == 'embed' && filteredPositionTypeSuggestion &&
                  filteredPositionTypeSuggestion.length > 0">
                    <ul *ngFor="let item of filteredPositionTypeSuggestion">
                      <li (click)="selectAutoComplete(item, 'positionType')">
                        <span class="name">{{item.value}}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="autosuggestion block" *ngIf="storyType == 'embed' && insidePositionType &&
                  filteredPositionTypeSuggestion && 1 > filteredPositionTypeSuggestion.length">
                    <ul>
                      <li><span class="name">No Results</span></li>
                    </ul>
                  </div>
                </div>
              </li>
            </div>
              <li>
                <label>Label</label>
                <div class="dataField">
                  <label class="switch" tabindex="0">
                    <input type="checkbox"
                    (click)="toggleSwitch('news')"
                      [checked]="showLabel">
                    <span class="slider round"></span>
                  </label>
                </div>
              </li>
              <li *ngIf= "domainConfig && domainConfig['config']
              && domainConfig['config']['elements'] && domainConfig['config']['elements']['adsLband'] === 'true'">
                <label>Ads L-band</label>
                <div class="dataField">
                  <label class="switch" tabindex="0">
                    <input type="checkbox"
                    (click)="toggleSwitch('L-band')"
                      [checked]="cardData.lshapeBand">
                    <span class="slider round"></span>
                  </label>
                </div>
              </li>
              <ng-container *ngIf="showLabel">
                <li>
                <label>Text</label>
                <div class="dataField">
                  <input placeholder="Add Label Text here…" type="text"
                  (ngModelChange)="labelChanges($event)"
                  [class]="(cardData.embed.label.text) ? 'textBox' : 'textBox errorInput'"
                  [(ngModel)]="cardData.embed.label.text"
                  class="textBox">
                </div>
              </li>
              <li>
                <label>Background Color</label>
                <div class="dataField">
                  <input type="text" placeholder="Red" disabled class="textBox">
                </div>
              </li>
              <li>
                <label>Font Color</label>
                <div class="dataField">
                  <input placeholder="white" type="text" disabled class="textBox">
                </div>
              </li>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="storyType === 'jsonfeed'">
          <li>
            <label>JSON Source Url</label>
            <div class="dataField">
              <input type="text" id="inputAddJsonSourceUrl" [class]="(cardData.jsonSourceUrl || cardData.embed.body) ? 'textBox' : 'textBox errorInput'"
              [(ngModel)]="cardData.jsonSourceUrl"
                placeholder="Add jsonSourceUrl here…">
            </div>
          </li>
          <li>
            <label>Sub Type</label>
           <!--  <div class="dataField">
              <select [(ngModel)]="cardData.subType" class="selectBox" (change)="selectSubType($event.target.value)">
                <option value="">Please select subTypes</option>
                <option *ngFor="let c of subTypes">{{c}}</option>
              </select>
            </div> -->
            <div class="dataField">
              <input type="text" class="textBox" id="inputAddSubType" #subTypeInput placeholder="Add SubType here."
              [class]="(subtypeQuery || (domainConfig && domainConfig.config && domainConfig.config.jsonfeed && domainConfig.config.jsonfeed.subtype && (domainConfig.config.jsonfeed.subtype === 'false'))) ? 'textBox' : 'textBox errorInput'"
                [(ngModel)]="subtypeQuery" (keyup)="filterAutoCompleteUp($event)" (keydown)="filterAutoCompleteDown($event)"
                (focus)="focusInSuggest('agency')" (focusout)="false">
              <ng-container >
                <div class="autosuggestion block" *ngIf="filteredsubTypeSuggestion && filteredsubTypeSuggestion.length > 0">
                  <ul *ngFor="let item of filteredsubTypeSuggestion; let i = index">
                    <li #agencyList (click)="selectAutoCompleteSubType(item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                      <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideSubType && (1 > filteredsubTypeSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
          <!-- Tag Type -->
          <li *ngIf="enableTagTypeApp">
            <label>Tag Type App</label>
            <div class="dataField">
              <input type="text" class="textBox" id="inputAddTagType" #tagTypeInput placeholder="Add TagType here."
                [(ngModel)]="tagtypeQuery" (keyup)="filterAutoCompleteUpTagType($event)" (keydown)="filterAutoCompleteDownTagType($event)"
                (focus)="focusInSuggestTagType('agency')" (focusout)="false">
              <ng-container >
                <div class="autosuggestion block" *ngIf="filteredtagTypeSuggestion && filteredtagTypeSuggestion.length > 0">
                  <ul *ngFor="let item of filteredtagTypeSuggestion; let i = index">
                    <li #agencyList (click)="selectAutoCompleteTagType(item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                      <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideTagType && (filteredtagTypeSuggestion && 1 > filteredtagTypeSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="storyType === 'placeholder'">
          <li>
            <label>Sub Type</label>
            <div class="dataField">
              <input type="text" class="textBox" id="inputAddSubType" #subTypeInput placeholder="Add SubType here."
                [(ngModel)]="subtypeQuery" (keyup)="filterAutoCompleteUp($event)" (keydown)="filterAutoCompleteDown($event)"
                (focus)="focusInSuggest('agency')" (focusout)="false">
              <ng-container >
                <div class="autosuggestion block" *ngIf="filteredsubTypeSuggestion && filteredsubTypeSuggestion.length > 0">
                  <ul *ngFor="let item of filteredsubTypeSuggestion; let i = index">
                    <li #agencyList (click)="selectAutoCompleteSubType(item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideSubType && (1 > filteredsubTypeSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
          <!-- Tag Type -->
          <li>
            <label>Tag Type</label>
            <div class="dataField">
              <input type="text" class="textBox" id="inputAddTagType" #tagTypeInput placeholder="Add TagType here."
                [(ngModel)]="tagtypeQuery" (keyup)="filterAutoCompleteUpTagType($event)" (keydown)="filterAutoCompleteDownTagType($event)"
                (focus)="focusInSuggestTagType('agency')" (focusout)="false">
              <ng-container >
                <div class="autosuggestion block" *ngIf="filteredtagTypeSuggestion && filteredtagTypeSuggestion.length > 0">
                  <ul *ngFor="let item of filteredtagTypeSuggestion; let i = index">
                    <li #agencyList (click)="selectAutoCompleteTagType(item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideTagType && (filteredtagTypeSuggestion && 1 > filteredtagTypeSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>

        </ng-container>
        </ng-template>


        <ng-container *ngIf="storyType == 'chart' && chartConfig && chartConfig.options">
          <li>
            <label>Chart Type</label>
            <div class="datafield">
              <select name="recordList" class="select-wrapper" [ngModel]="chartType" (ngModelChange)="changeInType($event)">
                <ng-container *ngFor="let type of chartTypes">
                  <option [selected]="type === chartType" [value]="type">{{type}}</option>
                </ng-container>
              </select>
            </div>
          </li>
          <li>
            <label>Chart Label</label>
            <div class="dataField">
              <input type="text" class="textBox" [readOnly]="!editCardFlag"
              [(ngModel)]="chartLabels.chartlabel"
              placeholder="Add Chart name here…" (change)="generateChart()">
            </div>
          </li>
          <ng-container *ngIf="chartType === 'line' || chartType === 'bar'">
            <li>
              <label>X-Axis Label</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!editCardFlag"
                [(ngModel)]="chartLabels.xlabel"
                placeholder="Add X-Axis label here…" (change)="generateChart()">
              </div>
            </li>
            <li>
              <label>Y-Axis Label</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!editCardFlag"
                [(ngModel)]="chartLabels.ylabel"
                placeholder="Add Y-Axis label here…" (change)="generateChart()">
              </div>
            </li>
          </ng-container>
        </ng-container>
        <ng-container class="enableWebAppAmpFlagTenants" *ngIf="enableAmpWebAppFlag && ampWebAppTypeElements.indexOf(storyType)>-1">
          <li *ngIf="typeCollectionFlags.indexOf('app')>-1">
            <label>APP</label>
            <div class="dataField">
              <label class="switch" tabindex="0">
                <input type="checkbox" [readonly]="!editCardFlag" [checked]="cardData.metadata.app" (click)="toggleSwitch('APP')">
                <span class="slider round"></span>
              </label>
            </div>
          </li>

          <li *ngIf="typeCollectionFlags.indexOf('amp')>-1">
            <label>AMP</label>
            <div class="dataField">
              <label class="switch" tabindex="0">
                <input type="checkbox" [readonly]="!editCardFlag" [checked]="cardData.metadata.amp" (click)="toggleSwitch('AMP')">
                <span class="slider round"></span>
              </label>
            </div>
          </li>

          <li *ngIf="typeCollectionFlags.indexOf('web')>-1">
            <label>WEB</label>
            <div class="dataField">
              <label class="switch" tabindex="0">
                <input type="checkbox" [readonly]="!editCardFlag" [checked]="cardData.metadata.web" (click)="toggleSwitch('WEB')">
                <span class="slider round"></span>
              </label>
            </div>
          </li>
          <li *ngIf="typeCollectionFlags.indexOf('excludeAutomatedContent')>-1">
            <label>Exclude Automated Content</label>
            <div class="dataField">
              <label class="switch" tabindex="0">
                <input type="checkbox" [readonly]="!editCardFlag" [checked]="cardData.metadata.excludeAutomatedContent" (click)="toggleSwitch('excludeAutomatedContent')">
                <span class="slider round"></span>
              </label>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="(storyType==='embed' || storyType==='collection') && domainConfig['config']['story']['enabledMatchIdField']">
          <li [ngClass]="{'hide-field':false}">
            <label>Match ID</label>
            <div class="dataField" style="font-size: 17px;margin-top: 10px;" *ngIf="!cardData.metadata.matchDetail">
             <i class="icon-add-headline" (click)="openMatchPopupMeta()"></i>
            </div>
            <div style="display: flow-root;">
              <span class="select-match" *ngIf="cardData.metadata.matchDetail && cardData.metadata.matchDetail.seriesName">{{cardData.metadata.matchDetail.seriesName}}</span>
              <span class="select-match" *ngIf="cardData.metadata.matchDetail && cardData.metadata.matchDetail.seriesName">{{cardData.metadata.matchDetail.matchNameWithDate}}</span>
            </div>
              <div style="margin-left: 15rem;" *ngIf="cardData.metadata.matchDetail">
                <i class="icon-pickup" (click)="openEditMatchPopupMeta()"></i>
                <i style="padding-left: 10px;" class="icon-delete" (click)="deleteMatchDetails()"></i>
              </div>
          </li>
        </ng-container>
        <div *ngIf="storyType === 'placeholder'" class="banner_head">
          <h3 class="head">Banner Data</h3>
          <li>
              <label>Banner Title</label>
              <div class="dataField">
                <input type="text" class="textBox" id="inputDisplayNameText"
                [(ngModel)]="cardData.metadata.banner.title"
                  placeholder="Add Title here…">
              </div>
          </li>
          <li>
            <label>Banner Description</label>
            <div class="dataField">
              <input type="text" class="textBox" id="inputDisplayNameText"
              [(ngModel)]="cardData.metadata.banner.description"
                placeholder="Add Description here…">
            </div>
        </li>
        <li>
          <label>Banner DeeplinkUrl</label>
          <div class="dataField">
            <input type="text" class="textBox" id="inputDisplayNameText"
            [(ngModel)]="cardData.metadata.banner.deeplinkUrl"
              placeholder="Add Deepklink URL here…">
          </div>
        </li>
        <li>
          <label>Banner CTA</label>
          <div class="dataField">
            <input type="text" class="textBox" id="inputDisplayNameText"
            [(ngModel)]="cardData.metadata.banner.cta"
              placeholder="Add CTA here…">
          </div>
        </li>
        <li>
        <label>Banner Design</label>
        <div class="dataField">
          <input type="text" class="textBox" #sectionInput placeholder="Select design here." readonly
          [(ngModel)]="bannerDesignQuery" (click)="filterAutoComplete()">
          <div class="autosuggestion block" *ngIf="filteredBannerDesignSuggestion && filteredBannerDesignSuggestion.length > 0">
            <ul *ngFor="let item of filteredBannerDesignSuggestion">
              <li (click)="selectAutoComplete(item, 'bannerDesign')">
                <span class="name">{{item.value}}</span>
              </li>
            </ul>
          </div>
          <ng-container *ngIf="insideDesign && (1 > filteredBannerDesignSuggestion.length)">
            <div class="autosuggestion block">
              <ul>
                <li><span class="name">No Results</span></li>
              </ul>
            </div>
          </ng-container>
        </div>
      </li>
      <li>
      <label>Banner Image</label>
        <div class="dataField">
            <div class="uploadimage"><i class="icon-upload"></i>
              <div class="upload-btn-wrapper relative"> <span>Upload Image</span>
                <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event,'bannerImage')"/>
              </div>
            </div>
            <span *ngIf="cardData.metadata.banner.imageUrl && !pickStoryImageLoad" class="deleteImage" (click)="deleteImage('bannerImage')">
              <i class="icon-delete"></i></span>
            <div class="cover-image">
              <ng-container *ngIf="(pickStoryImageLoad || croppingInProgress)">
                <div class="imagepreloader">
                  <div class="a" style="--n: 5;">
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="cardData.metadata.banner && cardData.metadata.banner.imageUrl">
                <img alt="" width="200" height="100" src="{{cardData.metadata.banner.imageUrl}}"
                                                style="visibility: visible; object-fit: contain;">
              </ng-container>
            </div>
          </div>
        </li>
      </div>
        </ul>
      </div>
      <!-- <div id="page_saveBtn1">
        <span class="created">
          {{changeFlag ? 'SAVING CHANGES...': 'ALL CHANGES ARE SAVED'}}</span>
        <button type="button" (click)="cardPush(true)" [disabled]="!namePresent" class="green">Publish</button>
      </div> -->
    </div>

  </div>

  <div class="lightBox cropimagelightbox block" *ngIf="tablePopup">

    <div class="unlockStory">
      <div class="wid100">
        <h3 class=" pad30">Table</h3>
        <div class="cropimageblock pad30">
          <div class="cropAspectRatio">
              <ckeditor #editorTable [editor]="Editor"
              (ready)="initializeEditor()"
              [(ngModel)]="tableHTML"  [config]="tableConfig"
              (ready)="ckchanges($event, 'ready', 'table','table')"
              (change)="ckchanges($event, 'change', 'table','table')"
              ></ckeditor>
          </div>
        </div>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" (click)="closeTable()" class="cancel gray ml10">Cancel</button>
        <button type="button" name="unlock" (click)="saveTable()" class='add blue ml10'>Done</button>
      </div>
    </div>
</div>
</ng-container>
<ng-template #loading>
    <div class="imagepreloader">
        <div class="a" style="--n: 5;">
          <div class="dot dot1" style="--i: 0;"></div>
        <div class="dot dot2" style="--i: 1;"></div>
        <div class="dot dot3" style="--i: 2;"></div>
        <div class="dot dot4" style="--i: 3;"></div>
        </div>
      </div>
</ng-template>

<div class="lightBox embeddblock matchBlock block" *ngIf="matchPopupMeta">
  <app-match-component (sendPopupValueToParentfn)="getPopupValueToParentfnMeta($event)"
  (sendMatchDetailsToParentfn) = getMatchDetails($event)
  ></app-match-component>
</div>

<div class="lightBox embeddblock matchBlock block" *ngIf="editMatchPopupMeta">
  <app-match-component (sendPopupValueToParentfn)="getPopupValueToParentfnMeta($event)"
  (sendMatchDetailsToParentfn) = getMatchDetails($event)
  [seriesName]="cardData.metadata.matchDetail.seriesName"
  [matchId]="cardData.metadata.matchDetail.matchId"
  ></app-match-component>
</div>

